import { useLocation } from 'react-router-dom';

import { Introduction } from '../Introduction';
import { Sections } from '../Sections';

import { ECourseContentStep } from '@/types';

const CONTENT_COMPONENTS = {
  [ECourseContentStep.INTRODUCTION]: Introduction,
  [ECourseContentStep.SECTIONS]: Sections
} as const;

export const Content: React.FC = () => {
  const { search } = useLocation();
  const activeContentTab = new URLSearchParams(search).get('contentTab');

  if (!activeContentTab || !Object.keys(CONTENT_COMPONENTS).includes(activeContentTab)) {
    return null;
  }

  const ContentComponent = CONTENT_COMPONENTS[activeContentTab as keyof typeof CONTENT_COMPONENTS];

  return <ContentComponent />;
};
